import PropTypes from "prop-types";

const GoalMetricCard = ({ title, number, description, icon: Icon }) => {
  // used on Goals page - showing status, progress - 2nd section
  return (
    <div className="p-4 card-base card-base-background w-auto card-base-border">
      <div className="flex flex-col justify-between h-full">
        <h4 className="text-sm">{title}</h4>
        <p className="text-2xl">{number}</p>
        <p className="text-xs">{description}</p>
      </div>
    </div>
  );
};

GoalMetricCard.propTypes = {
  title: PropTypes.string.isRequired,
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.node]).isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.object,
};

export default GoalMetricCard;
